import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CameraServerService } from '../../camera-server.service';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { AppConstants } from 'src/app/shared/app-constants';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface TableElementCamera {
  unique_id: number;
  camera_id: string;
  camera_name: string;
  camera_type: string;
  site_name: string;
  PTZ: string;
  active: boolean;
  analytic_name: string;
}

export interface TableElementCamera {
  unique_id: number;
  camera_id: string;
  camera_name: string;
  camera_type: string;
  site_name: string;
  PTZ: string;
  active: boolean;
  analytic_name: string;
}

export interface TableElementDevice {
  unique_id: number;
  name: string;
  device_type: string;
  site_name: string;
}

export interface TableElementOutputs {
  unique_id: number;
  display_name: string;
  alarm_type: string;
  site_name: string;
  address: string;
}
export interface TableElementStrobes {
  strobe_unique_id: number;
  strobe_id: string;
  strobe_name: string;
  site_name: string;
  port_number: string;
}

export const DEVICE_CONFIGURATION = [
  { id: "1", name: "All", value: "ALL" },
  { id: "2", name: "Device Configuration", value: "OTHER_DEVICE_DATA" },
  { id: "3", name: "Output Configuration", value: "OUTPUT_DATA" },
  { id: "4", name: "Algo Strobe Configuration", value: "STROBE_DATA" },
]

@Component({
  selector: 'app-camera-view-dialog',
  templateUrl: './camera-view-dialog.component.html',
  styleUrls: ['./camera-view-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
,
  standalone: false
})

export class CameraViewDialogComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @ViewChild('devicePaginator') devicePaginator: MatPaginator;
  @ViewChild('deviceSort') deviceSort: MatSort;

  @ViewChild('outputPaginator') outputPaginator: MatPaginator;
  @ViewChild('outputSort') outputSort: MatSort;

  @ViewChild('strobePaginator') strobePaginator: MatPaginator;
  @ViewChild('strobeSort') strobeSort: MatSort;

  potentialId: any = ""
  displayedColumnsCamera: string[] = ['unique_id', 'camera_name', 'camera_type', 'site_name', 'active', 'analytic_name', 'connected'];
  dataSourceCamera = new MatTableDataSource<TableElementCamera>([]);
  totalRecords = 0;
  pageSize = 10;
  pageIndex = 0;
  displayedColumnsDevice: string[] = ['deviceUniqueId', 'deviceName', 'deviceType', 'ip', 'username', 'device_class', 'action'];

  dataSourceDevice = new MatTableDataSource<TableElementDevice>([]);
  dataSourceOutputs = new MatTableDataSource<TableElementOutputs>([]);
  dataSourceStrobes = new MatTableDataSource<TableElementStrobes>([]);

  totalRecordsDevice: number = 0;
  pageSizeDevice: number = 10;
  pageIndexDevice: number = 0;

  totalRecordsOutputs: number = 0;
  pageSizeOutputs: number = 10;
  pageIndexOutputs: number = 0;

  totalRecordsStrobes: number = 0;
  pageSizeStrobes: number = 10;
  pageIndexStrobes: number = 0;

  loading: boolean = false;
  headTitle: string = '';
  isVisibleTables: boolean = false;
  selectDeviceConfiguration: string = "ALL";
  deviceConfigurationList: any = DEVICE_CONFIGURATION;
  isDeviceTable: boolean = true;
  isOutputTable: boolean = true;
  isStrobeTable: boolean = true;
  site_name: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private camService: CameraServerService,
    private toasts: ToastrService,
    public spinner: SpinnerService,
  ) { }

  ngOnInit(): void {
    if (this.data.potentialId) {
      this.potentialId = this.data.potentialId;
      this.isVisibleTables = this.data.isDevice;
      this.site_name = this.data.siteName
      if (this.data.isDevice) {
        this.getAllDeviceListForSite();
        this.headTitle = 'View Devices';
      } else {
        this.getCameraListForSite();
        this.headTitle = 'View Camera';
      }
    }
    if (this.selectDeviceConfiguration === 'ALL') {
      this.isDeviceTable = true;
      this.isOutputTable = true;
      this.isStrobeTable = true;
    }
  }

  ngAfterViewInit() {
    this.dataSourceCamera.paginator = this.paginator;
    this.sort?.active
    this.dataSourceCamera.sort = this.sort;
    this.sort?.direction
    this.sort?.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    this.dataSourceDevice.paginator = this.devicePaginator;
    this.pageIndexDevice = this.devicePaginator?.pageIndex;
    // this.pageSizeDevice = this.devicePaginator?.pageSize;

    this.dataSourceStrobes.paginator = this.strobePaginator;
    this.pageIndexStrobes = this.strobePaginator?.pageIndex;
    // this.pageSizeStrobes = this.strobePaginator?.pageSize;

    this.dataSourceOutputs.paginator = this.outputPaginator;
    this.pageIndexOutputs = this.outputPaginator?.pageIndex;
    // this.pageSizeOutputs = this.outputPaginator?.pageSize;

    this.deviceSort?.active;
    this.outputSort?.active;
    this.strobeSort?.active;

    this.dataSourceDevice.sort = this.deviceSort;
    this.dataSourceOutputs.sort = this.outputSort;
    this.dataSourceStrobes.sort = this.strobeSort;

    this.deviceSort?.direction;
    this.outputSort?.direction;
    this.strobeSort?.direction;

    this.deviceSort?.sortChange.subscribe(() => (this.devicePaginator.pageIndex = 0));
    this.outputSort?.sortChange.subscribe(() => (this.outputPaginator.pageIndex = 0));
    this.strobeSort?.sortChange.subscribe(() => (this.strobePaginator.pageIndex = 0));
  }

  /**Get all camera related to particular site based on the site potential ID */
  getCameraListForSite() {
    if (this.potentialId) {
      this.spinner.activate();
      this.loading = true;
      this.camService.getCamByPotentialId(this.potentialId).subscribe((response: any) => {
        if (response && response.success) {
          this.dataSourceCamera = new MatTableDataSource<any>(response?.data?.cams || []);
          this.dataSourceCamera.paginator = this.paginator;
          this.totalRecords = response?.data?.totalRecords;
          this.dataSourceCamera.sort = this.sort;
          this.spinner.deactivate();
          this.loading = false;
        } else {
          this.spinner.deactivate();
          this.loading = false;
          this.toasts.error(response.message || AppConstants.noDataFound);
        }
      }, (err) => {
        this.loading = false;
        this.spinner.deactivate();
        if (err && err.error && err.error.message && err.error.message.length > 0) {
          this.toasts.error(err.error.message, 'Error');
        } else {
          this.toasts.error(AppConstants.defaultErrorMessage, 'Error');
        }
      })
    }
  }

  changePaging(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    // this.getPagedData(this.pageSize, this.pageIndex, this.searchCameraFilterValue);
  }

  changePagingDevice(event: any) {
    this.pageIndexDevice = event.pageIndex;
    this.pageSizeDevice = event.pageSize;
    // this.getPagedData(this.pageSize, this.pageIndex, this.searchCameraFilterValue);
  }

  changePagingOutputs(event: any) {
    this.pageIndexOutputs = event.pageIndex;
    this.pageSizeOutputs = event.pageSize;
    // this.getPagedData(this.pageSize, this.pageIndex, this.searchCameraFilterValue);
  }

  changePagingStrobes(event: any) {
    this.pageIndexStrobes = event.pageIndex;
    this.pageSizeStrobes = event.pageSize;
    // this.getPagedData(this.pageSize, this.pageIndex, this.searchCameraFilterValue);
  }

  getAllDeviceListForSite() {
    if (this.potentialId) {
      this.spinner.activate();
      this.loading = true;
      this.camService.getAllDevices(this.potentialId).subscribe((response: any) => {
        if (response && response.success) {
          this.site_name = response?.data?.siteName;
          let otherDeviceListWithSiteName = [];
          let outputListWithSiteName = [];
          let strobesListWithSiteName = [];
          let commonDataWithAllDevices: any = [];
          if (response?.data?.otherDeviceList !== null) {
            otherDeviceListWithSiteName = response?.data?.otherDeviceList?.map((item: any) => {
              commonDataWithAllDevices.push({ ...item, deviceName: item?.otherDeviceData?.deviceName, deviceType: item?.otherDeviceData?.deviceType, ip: item?.otherDeviceData?.ip, username: item?.otherDeviceData?.username });
              return { ...item, deviceName: item?.otherDeviceData?.deviceName, deviceType: item?.otherDeviceData?.deviceType, ip: item?.otherDeviceData?.ip, username: item?.otherDeviceData?.username }
            })
          }
          if (response?.data?.outputDataList !== null) {
            outputListWithSiteName = response?.data?.outputDataList?.map((item: any) => {
              commonDataWithAllDevices.push({ ...item, deviceName: item?.outputData?.displayName, deviceType: item?.outputData?.deviceType, ip: item?.outputData?.ip, username: item?.outputData?.username });
              return { ...item, deviceName: item?.outputData?.displayName, deviceType: item?.outputData?.deviceType, ip: item?.outputData?.ip, username: item?.outputData?.username }
            })
          }
          if (response?.data?.strobeDataList !== null) {
            strobesListWithSiteName = response?.data?.strobeDataList?.map((item: any) => {
              commonDataWithAllDevices.push({ ...item, deviceName: item?.strobeData?.deviceName, deviceType: item?.strobeData?.deviceType, ip: item?.strobeData?.ip, username: item?.strobeData?.username });
              return { ...item, deviceName: item?.strobeData?.deviceName, deviceType: item?.strobeData?.deviceType, ip: item?.strobeData?.ip, username: item?.strobeData?.username }
            })
          }
          this.dataSourceDevice = new MatTableDataSource<any>(commonDataWithAllDevices || []);
          this.dataSourceDevice.paginator = this.devicePaginator;
          this.totalRecordsDevice = response?.data?.totalRecords || []?.length;
          this.dataSourceDevice.sort = this.deviceSort;

          // this.dataSourceOutputs = new MatTableDataSource<any>(outputListWithSiteName || []);
          // this.dataSourceOutputs.paginator = this.outputPaginator;
          // this.totalRecordsOutputs = response?.data?.outputDataList?.length || []?.length;
          // this.dataSourceOutputs.sort = this.outputSort;

          // this.dataSourceStrobes = new MatTableDataSource<any>(strobesListWithSiteName || []);
          // this.dataSourceStrobes.paginator = this.strobePaginator;
          // this.totalRecordsStrobes = response?.data?.strobeDataList?.length || []?.length;
          // this.dataSourceStrobes.sort = this.strobeSort;

          this.spinner.deactivate();
          this.loading = false;
        } else {
          this.spinner.deactivate();
          this.loading = false;
          this.toasts.warning(response.message || AppConstants.defaultErrorMessage);
        }
      }, (err) => {
        this.loading = false;
        this.spinner.deactivate();
        if (err && err.error && err.error.message && err.error.message.length > 0) {
          this.toasts.error(err.error.message, 'Error');
        } else {
          this.toasts.error(AppConstants.defaultErrorMessage, 'Error');
        }
      })
    }
  }

  /** This will call when user select the particular device type. */
  handleGetDeviceByClass() {
    this.spinner.activate();
    this.loading = true;
    if (this.selectDeviceConfiguration) {
      this.camService.getDeviceByClass(this.potentialId, this.selectDeviceConfiguration).subscribe((response: any) => {
        if (response && response.success) {
          this.site_name = response?.data?.siteName;
          let otherDeviceListWithSiteName = [];
          let outputListWithSiteName = [];
          let strobesListWithSiteName = [];
          let commonDataWithAllDevices: any = [];
          if (this.selectDeviceConfiguration === "OTHER_DEVICE_DATA") {
            if (response?.data?.otherDeviceList !== null) {
              otherDeviceListWithSiteName = response?.data?.otherDeviceList?.map((item: any) => {
                commonDataWithAllDevices.push({ ...item, deviceName: item?.otherDeviceData?.deviceName, deviceType: item?.otherDeviceData?.deviceType, ip: item?.otherDeviceData?.ip, username: item?.otherDeviceData?.username });
                return { ...item, deviceName: item?.otherDeviceData?.deviceName, deviceType: item?.otherDeviceData?.deviceType, ip: item?.otherDeviceData?.ip, username: item?.otherDeviceData?.username }
              })
            }
            this.dataSourceDevice = new MatTableDataSource<any>(commonDataWithAllDevices || []);
            this.dataSourceDevice.paginator = this.devicePaginator;
            this.totalRecordsDevice = response?.data?.totalRecords || []?.length;
            this.dataSourceDevice.sort = this.deviceSort;
            this.isDeviceTable = true;
            this.isOutputTable = false;
            this.isStrobeTable = false;
          }
          if (this.selectDeviceConfiguration === "OUTPUT_DATA") {
            if (response?.data?.outputDataList !== null) {
              outputListWithSiteName = response?.data?.outputDataList?.map((item: any) => {
                commonDataWithAllDevices.push({ ...item, deviceName: item?.outputData?.displayName, deviceType: item?.outputData?.deviceType, ip: item?.outputData?.ip, username: item?.outputData?.username });
                return { ...item, deviceName: item?.outputData?.displayName, deviceType: item?.outputData?.deviceType, ip: item?.outputData?.ip, username: item?.outputData?.username }
              })
            }
            this.dataSourceDevice = new MatTableDataSource<any>(commonDataWithAllDevices || []);
            this.dataSourceDevice.paginator = this.devicePaginator;
            this.totalRecordsDevice = response?.data?.totalRecords || []?.length;
            this.dataSourceDevice.sort = this.deviceSort;
            this.isDeviceTable = false;
            this.isOutputTable = true;
            this.isStrobeTable = false;
          }
          if (this.selectDeviceConfiguration === "STROBE_DATA") {
            if (response?.data?.strobeDataList !== null) {
              strobesListWithSiteName = response?.data?.strobeDataList?.map((item: any) => {
                commonDataWithAllDevices.push({ ...item, deviceName: item?.strobeData?.deviceName, deviceType: item?.strobeData?.deviceType, ip: item?.strobeData?.ip, username: item?.strobeData?.username });
                return { ...item, deviceName: item?.strobeData?.deviceName, deviceType: item?.strobeData?.deviceType, ip: item?.strobeData?.ip, username: item?.strobeData?.username }
              })
            }
            this.dataSourceDevice = new MatTableDataSource<any>(commonDataWithAllDevices || []);
            this.dataSourceDevice.paginator = this.devicePaginator;
            this.totalRecordsDevice = response?.data?.totalRecords || []?.length;
            this.dataSourceDevice.sort = this.deviceSort;
            this.isDeviceTable = false;
            this.isOutputTable = false;
            this.isStrobeTable = true;
          }
          if (this.selectDeviceConfiguration === "ALL") {
            this.getAllDeviceListForSite();
            this.isDeviceTable = true;
            this.isOutputTable = true;
            this.isStrobeTable = true;
          }
          this.spinner.deactivate();
          this.loading = false;
        } else {
          this.spinner.deactivate();
          this.loading = false;
          this.toasts.warning(response.message || AppConstants.defaultErrorMessage);
        }
      }, (err) => {
        this.loading = false;
        this.spinner.deactivate();
        if (err && err.error && err.error.message && err.error.message.length > 0) {
          this.toasts.error(err.error.message, 'Error');
        } else {
          this.toasts.error(AppConstants.defaultErrorMessage, 'Error');
        }
      })
    }
  }

  /** The  function for manual sync sites  */
  testOutput(element: any) {
    this.loading = true;
    this.spinner.activate();
    this.camService.testDevices(element.potentialId, element.deviceUniqueId).subscribe((response: any) => {
      if (response && response.success) {
        this.loading = false;
        this.spinner.deactivate();
        this.toasts.success(response?.data || 'Alarm triggered Successfully');
      } else {
        this.loading = false;
        this.spinner.deactivate();
        this.toasts.error(response?.data || AppConstants.defaultErrorMessage);
      }
    },
      (err) => {
        this.loading = false;
        this.spinner.deactivate();
        this.toasts.error(err.message || AppConstants.defaultErrorMessage);
      }
    );
  }


}
